import React from 'react'
import { TermsTypeEnum } from 'common/enum/terms-type'

// Added jun/2024
export default function TermGoodHabits() {
  return {
    name: TermsTypeEnum.TERM_GOOD_HABITS,
    title: 'Guia de boas práticas do Meu Mater Dei',
    content: (
      <>
        <div>
          <h2>1. Introdução</h2>
          <p>Prezado(a) colaborador(a), seja bem-vindo(a) ao Meu Mater Dei!</p>
          <p>
            O Meu Mater Dei é a plataforma da Rede Mater Dei de Saúde
            (“Hospital”) que concentra informações sobre médicos e pacientes e
            os procedimentos feitos por eles (“Plataforma”).
          </p>
          <p>
            Considerando que a Plataforma compila informações comerciais e dados
            pessoais sensíveis de saúde, elaboramos este Guia de Boas Práticas
            para o uso do Meu Mater Dei (“Guia”). É de suma importância que Você
            o leia e paute suas ações nas boas práticas aqui indicadas.
          </p>
          <p>
            Por meio da Plataforma, os médicos e pacientes podem cadastrar
            pedidos cirúrgicos, que serão apresentados para análise do Hospital.
          </p>
          <p>
            Os colaboradores do Hospital (denominados aqui como “Você”) deverão
            analisar os pedidos cirúrgicos recebidos pela Plataforma e
            encaminhar as solicitações para as operadoras de saúde, quando os
            procedimentos forem realizados por convênio. Você também poderá
            cadastrar novos pedidos cirúrgicos na Plataforma.
          </p>
          <p>
            Além disso, Você deverá apontar eventuais pendências constantes nos
            pedidos cirúrgicos, emitindo um alerta para os médicos, e realizar o
            cancelamento de pedidos cirúrgicos, quando solicitado pelos médicos
            ou pacientes.
          </p>
          <p>
            Ressaltamos que os termos deste Guia são complementares aos termos
            de eventuais contratos firmados entre Você e o Hospital, de modo que
            permanecem inalteradas as obrigações previstas nos referidos
            contratos.
          </p>
          <p>
            Caso seja constatado, ou haja suspeita, de que Você está fazendo uso
            indevido da Plataforma, o Hospital poderá, a seu exclusivo critério
            e por medida de segurança, suspender imediatamente o seu acesso à
            Plataforma, sem prejuízo das demais penalidades cabíveis.
          </p>
        </div>
        <div>
          <h2>2. Definições</h2>
          <p>
            2.1. Todos os termos referidos com inicial maiúscula neste Guia,
            incluindo o preâmbulo acima, seja no singular ou no plural, em ambos
            os gêneros, têm os significados atribuídos ao longo deste Guia,
            entre parênteses e aspas.
          </p>
        </div>
        <div>
          <h2>3. Boas práticas para uso da plataforma</h2>
          <p>
            3.1. Para mantermos a segurança da Plataforma e dos dados nela
            inseridos, recomendamos que Você:
          </p>
          <ol type="a">
            <li>
              utilize a Plataforma apenas para cumprir com a sua finalidade,
              qual seja, a gestão de pedidos cirúrgicos;
            </li>
            <li>
              mantenha a confidencialidade das informações e dados pessoais a
              que tiver acesso em razão da Plataforma;
            </li>
            <li>
              impeça que terceiros utilizem ou tenham acesso ao seu perfil ou à
              sua senha (todos os acessos realizados na Plataforma serão
              interpretados como tendo sito feitos por Você, de forma
              incontestável);
            </li>
            <li>mantenha seu cadastro atualizado;</li>
            <li>
              utilize apenas equipamentos eletrônicos fornecidos pelo Hospital,
              e, em não sendo possível, disponha de dispositivos, recursos e
              equipamentos tecnológicos com antivírus e firewall habilitados,
              softwares devidamente atualizados, além da adoção de medidas de
              segurança mínimas para acesso à Plataforma;
            </li>
            <li>
              respeite todos os direitos de propriedade intelectual de
              titularidade do Hospital;
            </li>
            <li>
              preste atenção com links maliciosos que possam comprometer a
              segurança do seu computador e, eventualmente, da Plataforma;
            </li>
            <li>
              comunique às pessoas responsáveis, imediatamente, qualquer
              incidente de segurança; e
            </li>
            <li>
              não envie documentações e informações para outros de fora do
              Hospital, a não ser para estrito cumprimento de suas funções.
            </li>
          </ol>
        </div>
        <div>
          <h2>4. Privacidade e proteção de dados</h2>
          <p>
            4.1 O tratamento dos Dados Pessoais inseridos na Plataforma ou
            informados por meio dos nossos canais de comunicação será regido
            pela Lei Geral de Proteção de Dados (Lei n.º 13.709/2018), com as
            diretrizes a serem emanadas pela Autoridade Nacional de Proteção de
            Dados e com as demais normas aplicáveis, bem como pela Política de
            Privacidade da Plataforma.
          </p>
          <p>
            4.2 É vedado informar os Dados Pessoais dos Titulares a terceiros
            não autorizados. Portanto, é sua obrigação conferir as credenciais
            dos terceiros que solicitam Dados Pessoais, em especial os Dados de
            saúde dos Pacientes.
          </p>
          <p>
            <b>4.3</b> Caso tenha qualquer dúvida, fique à vontade para entrar
            em contato conosco. Basta enviar uma mensagem à(o) nosso(a) DPO, por
            meio do contato{' '}
            <a
              href="mailto:dpo@materdei.com.br"
              target="_blank"
              rel="noreferrer"
              title="dpo@materdei.com.br "
            >
              dpo@materdei.com.br
            </a>{' '}
            ou por meio do{' '}
            <a
              href="https://www.materdei.com.br/institucional/dpo-mater-dei"
              target="_blank"
              rel="noreferrer"
              title="https://www.materdei.com.br/institucional/dpo-mater-dei"
            >
              formulário em nosso site
            </a>
            .
          </p>
        </div>
        <div>
          <h2>5. Propriedade intelectual</h2>
          <p>
            5.1 É concedida a Você uma licença limitada, individual, temporária,
            não exclusiva e intransferível para uso da Plataforma. Seu direito
            de usar a Plataforma está limitado às condições estabelecidos neste
            Guia.
          </p>
          <p>
            5.2. A Rede Mater Dei de Saúde é a única detentora dos direitos de
            propriedade intelectual sobre a marca e dos elementos componentes da
            Plataforma, incluindo, mas sem se limitar, softwares, códigos,
            domínios, tecnologias, textos, fotografias, vídeos, interfaces
            visuais, recursos interativos, gráficos, design, logo, marca,
            patentes, invenções ou outros elementos que constituam propriedade
            intelectual ou industrial.
          </p>
          <p>
            5.3. É vedado a Você modificar, reproduzir, republicar, criar,
            baixar, transmitir, distribuir, alugar, emprestar, vender, ceder,
            licenciar, sublicenciar, fazer engenharia reversa, exibir
            publicamente ou criar trabalhos derivados baseados na Plataforma, no
            todo ou em parte, exceto quando expressamente autorizado por escrito
            por Nós. Além disso, Nós não concedemos nenhum direito expresso ou
            implícito além dos dispostos nestes Termos.
          </p>
          <p>
            5.4. Sem prejuízo das penalidades previstas nestes Termos, caso Você
            descumpra a obrigações assumidas nesta cláusula, estará sujeito a
            indenizar o Hospital pelas perdas e danos cabíveis e lucros
            cessantes que lhe forem causados.
          </p>
        </div>
        <div>
          <p style={{ textAlign: 'right' }}>
            Belo Horizonte, 30 de abril de 2024.
          </p>
        </div>
      </>
    ),
    acceptMessage: `Declaro que li e aceito as condições do Guia de boas práticas do Meu Mater Dei`
  }
}
